import { Entity } from '@toeverything/infra';
import type { ReactNode } from 'react';

export class SidebarTab extends Entity<{
  id: string;
  label?: string;
  icon?: ReactNode;
}> {
  readonly id = this.props.id;
  readonly label = this.props.label;
  /** The tab's own icon, also shown where search offers the tab. */
  readonly icon = this.props.icon;
}
